import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { formatDateddMMyyyy } from 'helpers/dateHelper';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';

const KpiTargetTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  handleClickRow,
  onPageSizeChange,
  isFromManagerPage
}) => {
  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessor: 'id',
        Header: 'ID',
        isVisible: false
      },
      {
        accessor: 'saleUserId',
        Header: 'saleUserId',
        isVisible: false
      },
      {
        accessor: 'targetDate',
        Header: 'Apply From',
        Cell: rowData => {
          const { applyFrom } = rowData.row.original;
          // const date = getMondayOfIsoWeek(year, weekNumber);
          return formatDateddMMyyyy(applyFrom);
        }
      },
      {
        accessor: 'prospect',
        Header: 'Prospect'
      },
      {
        accessor: 'existing',
        Header: 'Existing'
      }
    ];

    if (isFromManagerPage) {
      baseColumns.push({
        accessor: 'saleUserIdAdmin',
        Header: 'Account Manager',
        Cell: rowData => {
          const { saleUserId } = rowData.row.original;
          return (
            <UsersInCellWidget usersText={saleUserId?.toString()} showName />
          );
        }
      });
    }

    return baseColumns;
  }, [isFromManagerPage]);

  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        handleClickRow={handleClickRow}
        textAlign=""
      />
    </>
  );
};

KpiTargetTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func,
  isFromManagerPage: PropTypes.bool
};

export default KpiTargetTable;
